import React from 'react';
import { DiscoveryBlock, DiscoveryProduct } from '@teko/discovery';
import { useDiscoverySearch, useNewProductCard, useTenantConfig } from 'hooks';
import { ProductCarouselWithHeader } from '@teko/teko-ecommerce';
import { convertObjectDiscoveryToQueryStringSearch } from 'helpers';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { isServerless } from 'helpers';

interface BestSellingProductsBlockProps {
  block: DiscoveryBlock;
  productPerView?: number;
  serverProducts?: DiscoveryProduct[];
}

export const BestSellingProductsBlock: React.FC<
  BestSellingProductsBlockProps
> = ({
  block,
  productPerView,
  serverProducts = [],
}: BestSellingProductsBlockProps) => {
  const { convertNewProductCard } = useNewProductCard();
  const { terminal, location } = useTenantConfig();

  const { result: bestSellingData, isLoading } = useDiscoverySearch(
    block && {
      ...block.cookedData.paramsObject,
      terminalCode: terminal,
      blockId: block.id,
      location,
      itemsPerPage: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
    },
  );

  const products =
    bestSellingData?.products?.length > 0
      ? bestSellingData.products
      : serverProducts;

  if (!isLoading && !products.length) return null;

  return (
    <ProductCarouselWithHeader
      header={{
        title: block.label,
        titleColor: 'white',
        link: {
          color: 'white',
          href:
            block?.viewMoreUrl ||
            `${convertObjectDiscoveryToQueryStringSearch(
              block?.cookedData?.paramsObject,
            )}`,
        },
      }}
      productsPerRow={productPerView || 5}
      products={(products as DiscoveryProduct[]).map((product) =>
        convertNewProductCard(product),
      )}
      background={block.backgroundImageUrl}
      virtual={isServerless()}
    />
  );
};
